const styles = {
  text: {
    fontSize: '16px',
    fontWeight: 800,
    lineHeight: '18.7px',
  },
};

export default styles;
